// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Y4BZk","type":"styles_type__1CUqr","choices":"styles_choices__27SE7"};